import { Injectable, inject } from '@angular/core'
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router'
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular'

@Injectable()
export class AppKeycloakGuard extends KeycloakAuthGuard {
  protected router: Router
  protected activeRoute = inject(ActivatedRoute)
  protected keycloakAngular: KeycloakService

  constructor() {
    const router = inject(Router)
    const keycloakAngular = inject(KeycloakService)

    super(router, keycloakAngular)

    this.router = router
    this.keycloakAngular = keycloakAngular
  }

  isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.authenticated) {
        this.keycloakAngular.login()
        return
      }

      const requiredRoles: string[] = route.data.roles
      if (!requiredRoles || requiredRoles.length === 0) {
        return resolve(true)
      }

      const keycloakInstance = this.keycloakAngular.getKeycloakInstance()
      const tokenParsed = keycloakInstance?.tokenParsed
      const resourceAccess = tokenParsed?.resource_access
      const clientId = keycloakInstance?.clientId
      const userRoles: string[] =
        (clientId && resourceAccess?.[clientId]?.roles) || []

      if (!userRoles || userRoles.length === 0) {
        return resolve(false)
      }

      const granted = requiredRoles.some((role) => userRoles.includes(role))
      resolve(granted)
    })
  }
}
